import { render, staticRenderFns } from "./ModalCriarDesenho.vue?vue&type=template&id=6dd567b4&scoped=true"
import script from "./ModalCriarDesenho.vue?vue&type=script&lang=js"
export * from "./ModalCriarDesenho.vue?vue&type=script&lang=js"
import style0 from "./ModalCriarDesenho.vue?vue&type=style&index=0&id=6dd567b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd567b4",
  null
  
)

export default component.exports